/** @jsx jsx */
import { jsx } from 'theme-ui';
import SearchWidget from '../components/searchwidget';
import { useStaticQuery, graphql } from 'gatsby';

const isMhCom = process.env.GATSBY_SITE_DOMAIN === 'com';
const searchName = isMhCom ? process.env.GATSBY_ALGOLIA_SEARCH_INDEX_COM : process.env.GATSBY_ALGOLIA_SEARCH_INDEX;

const searchIndices = [
  {
    name: searchName,
    title: `Pages`,
    hitComp: `PageHitOld`,
  },
];

const Search = (props) => {
  const data = useStaticQuery(graphql`
    query AllContentfulPagesQueryForSearch {
      allContentfulPage {
        edges {
          node {
            contentful_id
            slug
            node_locale
            parentPage {
              ... on ContentfulLayout {
                slug
              }
              ... on ContentfulPage {
                slug
                parentPage {
                  ... on ContentfulLayout {
                    slug
                  }
                }
              }
            }
          }
        }
      }
      allContentfulBlogPost {
        edges {
          node {
            contentful_id
            node_locale
            postType
            blog {
              contentful_id
              slug
            }
          }
        }
      }
    }
  `);
  const blogPostEdges = data.allContentfulBlogPost.edges.filter(({ node }) => node.postType !== 'Blog' || node.blog);

  return (
    <SearchWidget indices={searchIndices} edges={[...data.allContentfulPage.edges, ...blogPostEdges]} {...props} />
  );
};

export default Search;
